<!--
 * @Author: 温静 （wenjing@feihe.com）
 * @Date: 2022-03-24 17:21:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-21 13:52:43
 * @Description: 星妈课堂预约成功弹窗
-->
<template>
  <div class="mask" @touchmove.prevent @mousewheel.prevent>
    <div class="subscribe_box">
       <div class="subscribe_con">
        <div class="title">{{ data.message }}</div>
        <p v-for="(item, index) in tipArr" :key="index">{{item}}</p>
        <button @click="moreCourse">查看更多课程</button>
      </div>
      <i @click="close"></i>
    </div>
   
  </div>
</template>
<script>
export default {
  name: "subscribeSuccessCard",
  data() {
    return {
      tipArr: []
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  mounted() {
    this.handleTip()
  },
  methods: {
    // 处理预约成功信息
    handleTip() {
      this.tipArr = this.data.tips.split("，");
    },
    // 查看更多课程
    moreCourse() {
      if (this.$route.name == "courseList") {
        $(".successToast").fadeOut(200);
      } else {
        location.href = "/course";
      }
    },
    // 点击关闭
    close() {
      this.$emit("close");
    }
  }
}
</script>
<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.54);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .subscribe_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .subscribe_con{
      width: 242px;
      height: 172px;
      background: url("../../assets/images/nweHome/toast3.png") no-repeat;
      background-size: 290px 348px;
      padding: 152px 24px 24px;
      text-align: center;
      .title {
        font-size: 20px;
        color:#333;
        line-height: 28px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        color:#666;
        line-height: 22px;
        margin-top: 2px;
        &:first-child {
          margin-top: 0;
        }
      }
      button {
        width: 244px;
        height: 50px;
        margin-top: 14px;
        border: none;
        background: linear-gradient(270deg, #F0BA39 0%, #FBCF6F 100%);
        box-shadow: 0px 4px 8px 0px rgba(231, 170, 28, 0.3);
        border-radius: 25px;
        font-size: 18px;
        color: #fff;
      }
    }
    i {
      margin-top:30px;
      width: 24px;
      height: 24px;
      background: url("../../assets/images/nweHome/close.png") no-repeat;
      background-size: contain;
      display: block;
    }
  }
}
</style>
